import { NamespacedStoreState } from '@Types/store.types';

export const getSensorDataOverride = (state: NamespacedStoreState) =>
	state.entitlements.editSensorData?.sensorDataOverride;
